// extracted by mini-css-extract-plugin
export default {"PhotoCropInput":"bfu_a"};